var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_1398)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.1149L18.75 11.7688V17.8365C18.75 18.4103 18.5195 18.9606 18.1093 19.3663C17.6991 19.7721 17.1427 20 16.5625 20H3.4375C2.85734 20 2.30094 19.7721 1.8907 19.3663C1.48047 18.9606 1.25 18.4103 1.25 17.8365V11.7688L10 3.1149ZM17.2917 1.97115V7.01923L14.375 4.13462V1.97115C14.375 1.77989 14.4518 1.59646 14.5886 1.46122C14.7253 1.32598 14.9108 1.25 15.1042 1.25H16.5625C16.7559 1.25 16.9414 1.32598 17.0781 1.46122C17.2148 1.59646 17.2917 1.77989 17.2917 1.97115Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05741 0.400294C9.30743 0.143986 9.64648 0 10 0C10.3535 0 10.6926 0.143986 10.9426 0.400294L19.8045 9.48662C19.9297 9.61498 20 9.78908 20 9.97061C20 10.1521 19.9297 10.3262 19.8045 10.4546C19.6793 10.583 19.5096 10.6551 19.3325 10.6551C19.1555 10.6551 18.9858 10.583 18.8606 10.4546L10 1.3669L1.13941 10.4546C1.01424 10.583 0.844472 10.6551 0.667453 10.6551C0.490433 10.6551 0.320664 10.583 0.195492 10.4546C0.0703207 10.3262 0 10.1521 0 9.97061C0 9.78908 0.0703207 9.61498 0.195492 9.48662L9.05741 0.400294Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_1398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "1em",
    height: "1em",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.57702119c8f4a1737f7999315e4680fb.svg";
export { ForwardRef as ReactComponent };